module.exports = __webpack_public_path__ + "img/Group 2@3x.84c6bc15.png";